// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Label-staff .dialog-label .el-dialog {\n  max-height: 800px;\n  overflow-y: scroll;\n}\n.Label-staff .dialog-label .el-dialog__body {\n  padding-bottom: 10px;\n}\n.Label-staff .dialog-label .el-dialog__footer {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
